import React, { useCallback, useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";

import { BookingDataContext } from "containers/data_context";

import routes from "routing/routes";
import ApiActions from "api_actions";

export default function HeadManager() {
  const { t } = useTranslation();

  const { property, channelId } = useContext(BookingDataContext);
  const { data } = property;

  const isSearchPage = !!useRouteMatch(routes.searchPage);
  const isHotelPage = !!useRouteMatch(routes.hotelPage);
  const isPaymentPage = !!useRouteMatch(routes.paymentPage);
  const isConfirmationPage = !!useRouteMatch(routes.confirmationPage);
  const isDefaultPage = !!useRouteMatch(routes.default);
  const isUpdateBookingPage = !!useRouteMatch(routes.updateBookingPage);
  const [customPropertyData, setCustomPropertyData] = useState({});
  useEffect(() => {
    if (channelId) {
      const getCustomPropertyData = async () => {
        const apiData = await ApiActions?.getProperty(channelId);

        setCustomPropertyData({
          title: apiData?.data?.[0]?.custom_title,
          favIcon: apiData?.data?.[0]?.custom_favicon_url,
        });
      };
      getCustomPropertyData();
    }
  }, [channelId]);

  const getDocTitle = useCallback(() => {
    if (isSearchPage) {
      return t("global:search_page_doc_title");
    }

    if (isHotelPage || isPaymentPage || isConfirmationPage || isUpdateBookingPage) {
      return customPropertyData?.title ?? data?.title ?? t("global:loading");
    }
    if (isDefaultPage) {
      return "404";
    }

    return t("global:main_page_doc_title");
  }, [
    data,
    t,
    isConfirmationPage,
    isDefaultPage,
    isHotelPage,
    isUpdateBookingPage,
    isPaymentPage,
    isSearchPage,
    customPropertyData,
  ]);

  const docTitle = getDocTitle();

  return (
    <Helmet>
      <title>{docTitle}</title>

      {customPropertyData?.favIcon && <link rel="icon" href={customPropertyData.favIcon} />}
      {customPropertyData?.favIcon && (
        <link rel="shortcut icon" href={customPropertyData.favIcon} />
      )}
      {customPropertyData?.favIcon && (
        <link rel="apple-touch-icon" href={customPropertyData.favIcon} />
      )}
    </Helmet>
  );
}
